import React, { useState, useEffect } from "react";
import { Vendor } from "../../types/budgeting";

interface VendorDetailsProps {
  vendor: Vendor;
  updateVendorField: (field: keyof Vendor, value: string) => void;
  isViewMode: boolean;
}

const VendorDetails: React.FC<VendorDetailsProps> = ({
  vendor,
  updateVendorField,
  isViewMode,
}) => {
  const [errors, setErrors] = useState<{
    phoneNumber?: string;
    email?: string;
  }>({});

  useEffect(() => {
    const newErrors: { phoneNumber?: string; email?: string } = {};
    
    if (vendor.phoneNumber && !/^\d{10}$/.test(vendor.phoneNumber)) {
      newErrors.phoneNumber = "Phone number must be exactly 10 digits";
    }
    
    if (vendor.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(vendor.email)) {
      newErrors.email = "Invalid email format";
    }
    
    setErrors(newErrors);
  }, [vendor.phoneNumber, vendor.email]);

  return (
    <div className="bg-white p-0 rounded-md">
      <h3 className="font-semibold text-gray-700 mb-4">Vendor Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Name
          </label>
          <input
            type="text"
            placeholder="Enter name"
            className={`w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-sm ${
              isViewMode ? "bg-gray-100" : ""
            }`}
            value={vendor.name}
            onChange={(e) => updateVendorField("name", e.target.value)}
            disabled={isViewMode}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Phone Number
          </label>
          <input
            type="tel"
            placeholder="Enter phone number"
            className={`w-full border ${errors.phoneNumber ? "border-red-500" : "border-gray-300"} rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-sm ${
              isViewMode ? "bg-gray-100" : ""
            }`}
            value={vendor.phoneNumber}
            onChange={(e) => updateVendorField("phoneNumber", e.target.value)}
            disabled={isViewMode}
          />
          {errors.phoneNumber && !isViewMode && (
            <p className="text-red-500 text-xs mt-1">{errors.phoneNumber}</p>
          )}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            type="email"
            placeholder="Enter email"
            className={`w-full border ${errors.email ? "border-red-500" : "border-gray-300"} rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-sm ${
              isViewMode ? "bg-gray-100" : ""
            }`}
            value={vendor.email}
            onChange={(e) => updateVendorField("email", e.target.value)}
            disabled={isViewMode}
          />
          {errors.email && !isViewMode && (
            <p className="text-red-500 text-xs mt-1">{errors.email}</p>
          )}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Website Address
          </label>
          <input
            type="url"
            placeholder="Enter website address"
            className={`w-full border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-sm ${
              isViewMode ? "bg-gray-100" : ""
            }`}
            value={vendor.websiteAddress}
            onChange={(e) => updateVendorField("websiteAddress", e.target.value)}
            disabled={isViewMode}
          />
        </div>
      </div>
    </div>
  );
};

export default VendorDetails;